/**
Copyright (C) 2018 Andras Sarvari <andras.sarvari@sarvaria.net>

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted, provided that the above
copyright notice and this permission notice appear in all copies.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
*/

/* jshint browser: true, esversion: 6, node:true */
/* globals console */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PreviousIcon from './baseline_arrow_back_ios_white_24dp.png';
import NextIcon from './baseline_arrow_forward_ios_white_24dp.png';
import './Help.css';

/**
 * Represents the help screen.
 */

export default class Help extends Component {

    /**
     * Properties.
     */

    static propTypes = {
        context:            PropTypes.object.isRequired,
        screen:             PropTypes.string,
        onCloseHelp:        PropTypes.func.isRequired
    }

    /**
     * Default state.
     */
    
    state = {
        slide:  0,
        help:   {
            dashboard: [
                { area: { x: 8, y: 8, width: 42, height: 38 }, help: { x: 80, y: 60, content: this.props.context.locale.helps.dashboard.menubutton } },
                { area: { x: 11, y: 68, width: this.props.context.environment.screen.width - 104, height: 40 }, help: { x: 80, y: 120, content: this.props.context.locale.helps.dashboard.searchbox } },
                { area: { x: this.props.context.environment.screen.width - 93, y: 68, width: 80, height: 40 }, help: { x: this.props.context.environment.screen.width - 220, y: 120, content: this.props.context.locale.helps.dashboard.searchbutton } },
                { area: { x: 16, y: 120, width: this.props.context.environment.screen.width - 32, height: this.props.context.environment.screen.height - 200 }, help: { x: 100, y: 90, content: this.props.context.locale.helps.dashboard.content } }
            ],
            attributes: [
                { area: { x: 8, y: 8, width: 42, height: 38 }, help: { x: 80, y: 60, content: this.props.context.locale.helps.attributes.menubutton } },
                { area: { x: 11, y: 64, width: this.props.context.environment.screen.width - 24, height: this.props.context.environment.screen.height - 148 }, help: { x: 160, y: 28, content: this.props.context.locale.helps.attributes.attributelist } }
            ],
            entitytypes: [
                { area: { x: 8, y: 8, width: 42, height: 38 }, help: { x: 80, y: 60, content: this.props.context.locale.helps.entitytypes.menubutton } },
                { area: { x: 11, y: 64, width: this.props.context.environment.screen.width - 24, height: this.props.context.environment.screen.height - 148 }, help: { x: 160, y: 28, content: this.props.context.locale.helps.entitytypes.entitytypelist } }
            ],
            groups: [
                { area: { x: 8, y: 8, width: 42, height: 38 }, help: { x: 80, y: 60, content: this.props.context.locale.helps.groups.menubutton } },
                { area: { x: 11, y: 64, width: this.props.context.environment.screen.width - 24, height: this.props.context.environment.screen.height - 148 }, help: { x: 160, y: 28, content: this.props.context.locale.helps.groups.grouplist } }
            ],
            users: [
                { area: { x: 8, y: 8, width: 42, height: 38 }, help: { x: 80, y: 60, content: this.props.context.locale.helps.users.menubutton } },
                { area: { x: 11, y: 64, width: this.props.context.environment.screen.width - 24, height: this.props.context.environment.screen.height - 148 }, help: { x: 160, y: 28, content: this.props.context.locale.helps.users.userlist } }                
            ],
            settings: [
                { area: { x: 8, y: 8, width: 42, height: 38 }, help: { x: 80, y: 60, content: this.props.context.locale.helps.settings.menubutton } },
                { area: { x: 11, y: this.props.context.environment.browser.info.mobile ? 150 : 136, width: this.props.context.environment.browser.info.mobile ? (this.props.context.environment.screen.width - 24) : 358, height: 40 }, help: { x: 80, y: this.props.context.environment.browser.info.mobile ? 220 : 192, content: this.props.context.locale.helps.settings.username } },
                { area: { x: 14, y: this.props.context.environment.browser.info.mobile ? 320 : 266, width: this.props.context.environment.screen.width - 28, height: 188 }, help: { x: 80, y: this.props.context.environment.browser.info.mobile ? 286 : 232, content: this.props.context.locale.helps.settings.homedirectory } },
                { area: { x: this.props.context.environment.screen.width - 104, y: this.props.context.environment.browser.info.mobile ? 518 : 464, width: 90, height: 44 }, help: { x: this.props.context.environment.screen.width - 200, y: this.props.context.environment.browser.info.mobile ? 474 : 420, content: this.props.context.locale.helps.settings.savebutton } }
            ],
            general: [
                { area: { x: 8, y: 8, width: 42, height: 38 }, help: { x: 80, y: 60, content: this.props.context.locale.helps.dashboard.menubutton } }
            ]
        }
    }

    /**
     * Showing the previous slide.
     * 
     * @param   {Event} event   event object
     */

     _previousSlide = (event) => {

        // Stop event propagation

        event.stopPropagation();
        
        // Setting the previous slide

        this.setState({ slide: this.state.slide - 1});
    }

    /**
     * Showing the next slide.
     * 
     * @param   {Event} event   event object
     */

    _nextSlide = (event) => {

        // Stop event propagation

        event.stopPropagation();

        // Setting the next slide

        this.setState({ slide: this.state.slide + 1});
    }
    
    /** 
     * Event that fires when the component mounted.
     */

    componentDidMount() {

        // Help window closer

        let closeHelp = () => {
            this.props.onCloseHelp();
        };

        // Watching the click event. Closing the help if it happened.

        window.addEventListener('click', () => {
            window.removeEventListener('click', closeHelp);
            closeHelp();
        });
    }

    /** 
     * Help renderer.
     */

    render() {

        /**
         * Splits the specified text by using new lines.
         * 
         * @param   {String}    text        text that has to split
         * @return  {Object}    textElement generated text element
         */

        let breakLine = (text) => {
            let br = React.createElement('br');
            let regex = /(<br \/>)/g;

            return text.split(regex).map((line, index) => {
                return line.match(regex) ? <br key={"key_" + index} /> : line;
            });
        };

        return (
            <div className="help">

                {/* Backdrop */}

                <div className="help-backdrop" style={{ left: (this.state.help[this.props.screen] || this.state.help.general)[this.state.slide].area.x + 'px', top: (this.state.help[this.props.screen] || this.state.help.general)[this.state.slide].area.y + 'px', width: (this.state.help[this.props.screen] || this.state.help.general)[this.state.slide].area.width + 'px', height: (this.state.help[this.props.screen] || this.state.help.general)[this.state.slide].area.height + 'px' }}></div>

                {/* Help border */}

                <div className="help-border" style={{ width: this.props.context.environment.screen.width, height: this.props.context.environment.screen.height}}></div>

                {/* Content */}

                <div className="help-content" style={{ left: (this.state.help[this.props.screen] || this.state.help.general)[this.state.slide].help.x + 'px', top: (this.state.help[this.props.screen] || this.state.help.general)[this.state.slide].help.y + 'px'}}>
                    {breakLine((this.state.help[this.props.screen] || this.state.help.general)[this.state.slide].help.content)}
                </div>

                {/* Close comment */}

                <div className="help-close-comment">{this.props.context.environment.browser.info.mobile ? this.props.context.locale.help.closecomment_mobile : this.props.context.locale.help.closecomment_desktop}</div>

                {/* Slide indicator */}

                <div className="help-slider-container horizontal center center-justified">
                    {(this.state.help[this.props.screen] || this.state.help.general).map((item, index) =>
                        <div key={index} className={`help-slider ${this.state.slide === index ? 'help-slider-selected' : ''}`}></div>
                    )}
                </div>

                {/* Previous slide navigator */}

                { this.state.slide > 0 &&
                    <div className="help-navigator help-navigator-left vertical horizontal center center-justified" title={this.props.context.locale.help.previousslide_tooltip} onClick={this._previousSlide}>
                        <img alt="Previous slide" src={PreviousIcon} className="help-navigator-icon help-navigator-icon-left" />
                    </div>
                }

                {/* Next slide navigator */}

                { this.state.slide < ((this.state.help[this.props.screen] || this.state.help.general).length - 1) &&
                    <div className="help-navigator help-navigator-right vertical horizontal center center-justified" title={this.props.context.locale.help.nextslide_tooltip} onClick={this._nextSlide}>
                        <img alt="Next slide" src={NextIcon} className="help-navigator-icon help-navigator-icon-right" />
                    </div>
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Help/Help.js